// this is a hack to let the ChoiceEditor determine if a choice is new or existing
import api from "../../../../../../api";
import { NEW_QUESTION_CHOICE_PREFIX } from "../../../../../../constants/questions";

export const isNewQuestionChoice = (question: api.QuestionChoice) => question.id.startsWith(NEW_QUESTION_CHOICE_PREFIX);
